import { consume, ContextType } from '@lit/context';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { contexts } from '../contexts.js';
import { PagePull } from '../page-pull.js';

@customElement('pr-label')
export class PRLabel extends LitElement {
  @consume({ context: contexts.project, subscribe: true }) private _project?: ContextType<typeof contexts.project>;
  @consume({ context: contexts.dataSnapshotId, subscribe: true }) private _snapshotId?: ContextType<typeof contexts.dataSnapshotId>;

  @property({ type: Number }) number?: number;
  @property() state?: 'open' | 'closed' | 'merged';

  override render() {
    if (this.number === undefined)
      return nothing;
    const content = html`
      <fk-pr-icon .state=${this.state}></fk-pr-icon>
      <span class=text>#${this.number}</span>
    `;
    const title = '#' + this.number;
    const href = this._project ? PagePull.url({
      orgSlug: this._project.org.orgSlug,
      projectSlug: this._project.projectSlug,
      pullRequest: this.number,
      snapshotId: this._snapshotId,
    }) : undefined;
    if (href)
      return html`<a class="body ${this.state ?? ''}" href=${href} title=${title}>${content}</a>`;
    return html`<span class="body ${this.state ?? ''}" title=${title}>${content}</span>`;
  }

  static styles = css`
    :host {
      display: inline-block;
      flex: none;
    }

    * { box-sizing: border-box; }

    .body {
      display: inline-flex;
      align-items: center;
      gap: var(--sl-spacing-2x-small);
      padding: var(--sl-spacing-2x-small);
      border-radius: var(--sl-border-radius-large);
      color: var(--sl-color-neutral-600);
      background: var(--sl-color-neutral-100);
      text-decoration: none;
    }

    .open {
      color: green;
      background: #e6f4ea;
    }

    .merged {
      color: #9c27b0;
      background: #f3e5f5;
    }

    .closed {
      color: red;
      background: #fce4ec;
    }

    sl-icon {
      flex: none;
    }

    .text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `;
}
